import React, { Component } from 'react'
import { compose } from 'react-apollo'
import get from 'lodash.get'

import { getValidationErrors } from 'helpers/validation'
import { signup as signupMutation } from 'components/Signup/mutations'

import storage from 'storage/index'

import SignupUI from 'components/SignupUI'

class Signup extends Component {
  state = {
    loading: false,
    inputs: {
      email: '',
      password: ''
    },
    errors: {
      email: [],
      password: []
    }
  }

  handleSubmit = async () => {
    try {
      const { signup, match } = this.props
      const { inputs } = this.state

      this.setState({
        loading: true,
        errors: {
          email: [],
          password: []
        }
      })

      const response = await signup({
        email: inputs.email,
        password: inputs.password,
        action: match.params.action
      })

      const token = get(response, 'data.signup.authToken.token')
      const redirect = get(response, 'data.signup.redirect')

      await storage.setItem('token', token)

      window.location = redirect
    } catch (error) {
      this.setState({
        loading: false,
        errors: {
          ...this.state.errors,
          ...getValidationErrors(error)
        }
      })
    }
  }

  handleValueChange = (key, value) => {
    this.setState({
      inputs: {
        ...this.state.inputs,
        [key]: value
      }
    })
  }

  render() {
    const { loading, inputs, errors } = this.state

    return (
      <SignupUI
        emailValue={inputs.email}
        emailErrors={errors.email}
        onEmailChange={email => this.handleValueChange('email', email)}

        passwordValue={inputs.password}
        passwordErrors={errors.password}
        onPasswordChange={password => this.handleValueChange('password', password)}

        generalErrors={errors.general}
        isLoading={loading}

        onSubmit={this.handleSubmit}
      />
    )
  }
}

export default compose(
  signupMutation
)(Signup)



// WEBPACK FOOTER //
// ./src/components/Signup/index.js